/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PlannerPlaylistContainer_viewer$ref: FragmentReference;
export type PlannerPlaylistContainer_viewer = {|
  +id: string,
  +playlists: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +can_edit: ?boolean,
        +title: ?string,
        +description: ?string,
        +num_songs: ?number,
        +thumbnail: ?{|
          +url: ?string,
          +width: ?number,
          +height: ?number,
        |},
      |}
    |}>
  |},
  +public_playlists: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +can_edit: ?boolean,
        +title: ?string,
        +description: ?string,
        +num_songs: ?number,
        +thumbnail: ?{|
          +url: ?string,
          +width: ?number,
          +height: ?number,
        |},
      |}
    |}>
  |},
  +$refType: PlannerPlaylistContainer_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "can_edit",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "num_songs",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "thumbnail",
  "storageKey": "thumbnail(height:240,width:240)",
  "args": [
    {
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    },
    {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }
  ],
  "concreteType": "SongImage",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "url",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "width",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "height",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Fragment",
  "name": "PlannerPlaylistContainer_viewer",
  "type": "User",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "playlists"
        ]
      }
    ]
  },
  "argumentDefinitions": [],
  "selections": [
    v0,
    {
      "kind": "LinkedField",
      "alias": "playlists",
      "name": "__PlannerPlaylistContainer_playlists_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "PlaylistConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "PlaylistEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Playlist",
              "plural": false,
              "selections": [
                v0,
                v1,
                v2,
                v3,
                v4,
                v5,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "public_playlists",
      "storageKey": "public_playlists(first:99999)",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 99999,
          "type": "Int"
        }
      ],
      "concreteType": "PlaylistConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "PlaylistEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Playlist",
              "plural": false,
              "selections": [
                v0,
                v1,
                v2,
                v3,
                v4,
                v5
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '4a1ad43465957dbdb84b88fb81dcacd6';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/MusicPlanner/__generated__/PlannerPlaylistContainer_viewer.graphql.js